import { render, staticRenderFns } from "./DespViagens.vue?vue&type=template&id=34f1d338"
import script from "./DespViagens.vue?vue&type=script&lang=js"
export * from "./DespViagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports